import api from '../../../../api.js';

export const medAidApi = {
  getAcuteChronicStats: async (fromDate, toDate) => {
    try {
      // Build query parameters object
      const params = new URLSearchParams();
      
      // Add date parameters if they are provided
      if (fromDate) {
        params.append('fromDate', fromDate);
      }
      if (toDate) {
        params.append('toDate', toDate);
      }
      
      // Construct URL with query parameters
      const queryString = params.toString();
      const url = queryString 
        ? `/api/dispensary/reports/acute-chronic-stats?${queryString}`
        : '/api/dispensary/reports/acute-chronic-stats';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching acute/chronic stats:', error);
      throw error;
    }
  }
};